import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule, NgbPopoverModule, NgbDropdownModule, NgbNavModule, NgbActiveModal, NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { CarouselModule } from "ngx-owl-carousel-o";
import { CommonSvgIconComponent } from "./components/common-svg-icon/common-svg-icon.component";
import { ToastrModule } from "ngx-toastr";
import { NgApexchartsModule } from "ng-apexcharts";
import { NgSelectModule } from '@ng-select/ng-select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxDropzoneModule } from "ngx-dropzone";
import { PercentagePipe } from "../models/pipes/percentage.pipe";
import { CardCategoryComponent } from "./components/card-category/card-category.component";
import { CardComponent } from "./components/card/card.component";
import { CertificatePipe } from "../models/pipes/certificate.pipe";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TimeFormatPipe } from "../models/pipes/timeFormat.pipe";
import { DateFormatPipe } from "../models/pipes/dateFormat.pipe";
import { DashboardCompanyComponent } from "./components/dashboard-company/dashboard-company.component";
import { EmployeeStatusPipe } from "../models/pipes/employeesStatus.pipe";


@NgModule({
  declarations: [

  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule.forRoot(),
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    CarouselModule,
    NgbPopoverModule,
    NgbDropdownModule,
    CommonSvgIconComponent,
    ToastrModule.forRoot(),
    NgApexchartsModule,
    NgxDropzoneModule,
    NgSelectModule,
    FontAwesomeModule,
    PercentagePipe,
    CardCategoryComponent,
    CardComponent,
    NgbTypeaheadModule,
    CertificatePipe,
    PdfViewerModule,
    TimeFormatPipe,
    DateFormatPipe,
    EmployeeStatusPipe

  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CarouselModule,
    NgbNavModule,
    NgbModule,
    CommonModule,
    RouterModule,
    NgbPopoverModule,
    NgbDropdownModule,
    CommonSvgIconComponent,
    NgApexchartsModule,
    NgxDropzoneModule,
    NgSelectModule,
    FontAwesomeModule,
    PercentagePipe,
    CardCategoryComponent,
    CardComponent,
    NgbTypeaheadModule,
    CertificatePipe,
    PdfViewerModule,
    TimeFormatPipe,
    DateFormatPipe,
    EmployeeStatusPipe
    

  ],

  providers: [NgbActiveModal],
})
export class SharedModule { }
